const menuItemNames = {
  addAContext: 'Add a context',
  newCustomer: 'New customer',
  nftCreation: 'NFT creation',
  transferIngredient: 'Transfer ingredient',
  nftSelling: 'NFT transfer',
  nftFreezing: 'NFT freezing',
  nftThawing: 'NFT thawing',
  nftBurning: 'NFT burning',
  discountCondition: 'Discount conditions',
  nftDiscount: 'NFT Discounts',
};

export default menuItemNames;
